<template>
  <div class="common-exam-header">
    <div class="logo layout"></div>
  </div>
</template>

<script>
export default {
  name: 'CommonExamHeader'
};
</script>

<style lang="scss" scoped>
.common-exam-header {
  width: 100%;
  height: 71px;
  background: #fff;
  .logo {
    height: 71px;
    background: url('~@/assets/images/doExam/topHeaderNew.png') no-repeat;
  }
}
</style>
